module.exports = __webpack_public_path__ + "img/ararat-age-confirm-mobile-img-bottle.a34096e7.png";